import React, { memo } from 'react'

import MoreInformation from '../../../components/userAccount/MoreInformation'

const MoreInformationWrapper = (props) => {
  return <MoreInformation {...props} />
}

export default memo(MoreInformationWrapper)
